export default (html) => String(html)
  .trim()
  .replace(/<br ?\/?>/g, '\n');
